import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgot_password } from "../../redux/actions/adminActions";

const isValidEmail = (email) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);

const Forgot = () => {
  const [email, setEmail] = useState("");
  const [forgotError, setForgotError] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);

  const forgotPassword = useSelector((state) => state.forgotPassword);
  const { loading, error } = forgotPassword || {};
  const dispatch = useDispatch();

  const clear = () => setEmail("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      setIsEmpty(true);
      return;
    }
    dispatch(forgot_password(email, clear));
  };

  useEffect(() => {
    if (error) setForgotError(true);
  }, [error]);

  return (
    <form onSubmit={handleSubmit}>
      <p className="auth__pretitle">Roots Funding · Admin</p>
      <h1 className="auth__title">Forgot password</h1>
      <p className="auth__sub">We'll email you a reset link</p>

      <div className="auth__field">
        <label className="auth__label" htmlFor="forgot-email">Email</label>
        <input
          id="forgot-email"
          type="email"
          name="email"
          className="auth__input"
          placeholder="you@rootsfunding.com"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setForgotError(false);
            setIsEmpty(false);
          }}
          autoComplete="email"
        />
        {isEmpty && <span className="auth__error">Invalid email address</span>}
        {forgotError && <span className="auth__error">Email address not found or you are not yet registered</span>}
      </div>

      <button type="submit" className="auth__submit" disabled={loading}>
        {loading ? "Sending…" : "Send reset link"}
      </button>

      <Link to="/login" className="auth__link">Back to sign in</Link>
    </form>
  );
};

export default Forgot;
